import React from "react";
import { Modal } from "react-bootstrap";
//import "animate.css";

const PopUp = (props) => {
  return (
    <Modal
      size={`${props.size ? props.size : "md"}`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.smallmodalShow}
      onHide={() => props.setSmallModalShow(false)}
      className={`${props.className}-contant outer-pages new-design ${props.className}`}
      dialogClassName="animate__animated animate__fadeInUp"  // animation added here
    >
      <Modal.Header className={`${props.className}-header`}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="modal-title"
        >
          {props.title}
        </Modal.Title>
        { /** ms-auto class added by Urmila  */}
        <div className="registor-arrow-down close-icon ms-auto" onClick={() => props.setSmallModalShow(false)}></div>
      </Modal.Header>

      <Modal.Body className={`${props.className}-body`}>
        {props.children}
      </Modal.Body>

      <Modal.Footer className={`${props.className}-footer center`}>
        {/* Footer buttons if needed */}
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(PopUp);
